/* jshint node:true */
'use strict';

var React = require('react');

/* Components */
var LeagueTable         = require('./LeagueTable.jsx');
var NewsList            = require('./NewsList.jsx');
var MatchStats          = require('./MatchStats.jsx');
var AttackingStats      = require('./AttackingStats.jsx');
var MatchEvents         = require('./MatchEvents.jsx');
var KickPassRun         = require('./KickPassRun.jsx');
var SetPieces           = require('./SetPieces.jsx');
var Defending           = require('./Defending.jsx');
var Discipline          = require('./Discipline.jsx');
var Advert = require('../../common/Advert.jsx');
var AdReloaderMixin = require('../../../mixins/AdReloaderMixin.js');
var utils = require('../../../helpers/utils/index.js');

var TabMatchStats = React.createClass({

    displayName: 'TabMatchStats',
    
    mixins : [ AdReloaderMixin ],
    
    getInitialState : function(){
        return {
            adWrapSelector : '#reactContainer .react-ad'
        };
    },
    
    getPensConded: function(oStore){
        var penaltiesConceded = oStore.getStat('penaltiesConceded');
        return {
            home : {
                total : penaltiesConceded[0] || 0
            },
            away : {
                total : penaltiesConceded[1] || 0
            }
        };
    },
    
    getLineOutsWon: function(oStore){
        var totalLineouts = oStore.getStat('totalLineouts');
        var lineoutsWon = oStore.getStat('lineoutsWon');
        
        totalLineouts = totalLineouts.length ? totalLineouts : [0,0];
        lineoutsWon = lineoutsWon.length ? lineoutsWon : [0,0];
        
        return {
            home : {
                total : totalLineouts[0],
                won : lineoutsWon[0],
                percent : ((lineoutsWon[0])/totalLineouts[0]) * 100
            },
            away : {
                total : totalLineouts[1],
                won : lineoutsWon[1],
                percent : ((lineoutsWon[1])/totalLineouts[1]) * 100
            }
        };
    },
    
    getScrumsWon: function(oStore){
        var scrumsTotal = oStore.getStat('scrumsTotal');
        var scrumsLost = oStore.getStat('scrumsLost');
        
        scrumsTotal = scrumsTotal.length ? scrumsTotal : [0,0];
        scrumsLost = scrumsLost.length ? scrumsLost : [0,0];
        
        return {
            home : {
                total : scrumsTotal[0],
                won : scrumsTotal[0]-scrumsLost[0],
                percent : ((scrumsTotal[0]-scrumsLost[0])/scrumsTotal[0]) * 100
            },
            away : {
                total : scrumsTotal[1],
                won : scrumsTotal[1]-scrumsLost[1],
                percent: ((scrumsTotal[1]-scrumsLost[1])/scrumsTotal[1]) * 100
            }
        };
    },
    
    getTackles: function(oStore){
        var tackles = oStore.getStat('tackles') || [0,0];
        var missedTackles = oStore.getStat('missedTackles') || [0,0];
        
        tackles = tackles.length ? tackles : [0,0];
        missedTackles = missedTackles.length ? missedTackles : [0,0];
        
        return {
            home : {
                label : (tackles[0] - missedTackles[0]) + "/" + tackles[0],
                percent : Math.round(((tackles[0]-missedTackles[0])/tackles[0]) * 100)
            },
            away : {
                label : (tackles[1] - missedTackles[1]) + "/" + tackles[1],
                percent : Math.round(((tackles[1]-missedTackles[1])/tackles[1]) * 100)
            }
        };
    },
    
    getRunMetresPercent : function(metres){
        if(!metres.length || (metres[0] === 0 && metres[1] === 0)){
            return [0,0];
        }else if(metres[0] == metres[1]){
            return [50,50];
        }
        
        var teamAPercent = Math.round(metres[0]/(metres[0] + metres[1]) * 100);
        var teamBPercent = Math.abs(100 - teamAPercent);
        
        return [teamAPercent, teamBPercent];
    },
    
    getAttackingStats : function(oStore){
        // Get the Match stats for building a table
        var attackingStats = oStore.getMatchStats({
            pcPossessionFirst : {
                order : 1,
                name : 'Possession 1H/2H'
            },
            pcTerritoryFirst : {
                order : 2,
                name : 'Territory 1H/2H'
            },
            cleanBreaks : {
                order : 3,
                name : 'Line Breaks'
            },
            defendersBeaten : {
                order : 4,
                name : 'Defenders Beaten'
            },
            offload : {
                order : 5,
                name : 'Offloads'
            },
            rucksWon : {
                order : 6,
                name : 'Rucks Won'
            },
            maulsWon : {
                order : 7,
                name : 'Mauls Won'
            },
            turnoversConceded : {
                order : 8,
                name : 'Turnovers Conceded'
            }
        });
        
        // Get individual 1st/2nd half stats and override the values
        var pcPossessionSecond = oStore.getStat('pcPossessionSecond');
        var pcPossessionFirst = oStore.getStat('pcPossessionFirst');
        
        var pcTerritorySecond = oStore.getStat('pcTerritorySecond');
        var pcTerritoryFirst = oStore.getStat('pcTerritoryFirst');
        
        var rucksTotal = oStore.getStat('rucksTotal');
        var rucksWon = oStore.getStat('rucksWon');
        
        var maulsTotal = oStore.getStat('maulsTotal');
        var maulsWon = oStore.getStat('maulsWon');
        
        if(attackingStats[1]){
            attackingStats[1].home = Math.round(pcPossessionFirst[0]*100) + '% / ' + Math.round(pcPossessionSecond[0]*100) + '%';
            attackingStats[1].away = Math.round(pcPossessionFirst[1]*100) + '% / ' + Math.round(pcPossessionSecond[1]*100) + '%';
        }
        
        if(attackingStats[2]){
            attackingStats[2].home = Math.round(pcTerritoryFirst[0]*100) + '% / ' + Math.round(pcTerritorySecond[0]*100) + '%';
            attackingStats[2].away = Math.round(pcTerritoryFirst[1]*100) + '% / ' + Math.round(pcTerritorySecond[1]*100) + '%';
        }
        
        if(attackingStats[6]){
            attackingStats[6].home = rucksWon[0] + ' / ' + rucksTotal[0] + ' (' + Math.round((rucksWon[0]/rucksTotal[0] || 0)*100) + '%)';
            attackingStats[6].away = rucksWon[1] + ' / ' + rucksTotal[1] + ' (' + Math.round((rucksWon[1]/rucksTotal[1] || 0)*100) + '%)';
        }
        
        if(attackingStats[7]){
            attackingStats[7].home = maulsWon[0] + ' / ' + maulsTotal[0] + ' (' + Math.round((maulsWon[0]/maulsTotal[0] || 0)*100) + '%)';
            attackingStats[7].away = maulsWon[1] + ' / ' + maulsTotal[1] + ' (' + Math.round((maulsWon[1]/maulsTotal[1] || 0)*100) + '%)';
        }
        
        return attackingStats;
    },
    
    getEventStats: function(oStore){
        var eventStats = oStore.getMatchStats({
            tries : {
                order : 1,
                name : 'Tries'
            },
            conversionGoals : {
                order : 2,
                name : 'Conversions'
            },
            penaltyGoals : {
                order : 3,
                name : 'Penalties'
            },
            kickPercentSuccess : {
                order : 4,
                name : 'Kick at Goal Success'
            }
        });
        var kickPercentSuccess = oStore.getStat('kickPercentSuccess');
        if(eventStats[4]){
            eventStats[4].home = (kickPercentSuccess[0] * 100) + '%';
            eventStats[4].away = (kickPercentSuccess[1] * 100) + '%';
        }
        return eventStats;
    },

    render: function () {

        var sState = this.props.matchState || 'pre'; //pre,post,live
        var oStore = this.props.store;
        var rSummary = null;

        /* Load in the data from the Store */
        var aLeagueTable = oStore.getLeagueTable();
        var leagueName = oStore.getLeagueName();
        var newsList = oStore.getNewsList();
        var possession = oStore.getStatPercent('possession');
        var territory = oStore.getStatPercent('territory');
        var gameStripProps = oStore.getGameStripDetails();
        var homeLogo = utils.getImageUrl(gameStripProps.teams.home.logo);
        var awayLogo = utils.getImageUrl(gameStripProps.teams.away.logo);
        var home = oStore.getHomeTeam() || {};
        var away = oStore.getAwayTeam() || {};
        var colors = [home.color, away.color];
        var homeTeam = {logo: homeLogo, abbreviation: gameStripProps.teams.home.abbreviation};
        var awayTeam = {logo: awayLogo, abbreviation: gameStripProps.teams.away.abbreviation};
        var metres = oStore.getStat('metres');
        var metresPercent = this.getRunMetresPercent(metres);
        var tackles = this.getTackles(oStore);
        var pensConceded = this.getPensConded(oStore);
        var scrumsWon = this.getScrumsWon(oStore);
        var lineoutsWon = this.getLineOutsWon(oStore);
        var attackingStats  = this.getAttackingStats(oStore);
        var eventStats = this.getEventStats(oStore);
        var kickPassRunStats = oStore.getMatchStats({
            kicksFromHand : {
                order : 1,
                name : 'Kicks From Hand'
            },
            passes : {
                order : 2,
                name : 'Passes'
            },
            runs : {
                order : 3,
                name : 'Runs'
            }
        });
        var disciplineStats = oStore.getMatchStats({
            redCards : {
                order : 1,
                name : 'Red Cards'
            },
            yellowCards : {
                order : 2,
                name : 'Yellow Cards'
            },
            totalFreeKicksConceded : {
                order : 3,
                name : 'Free Kicks Conceded'
            }
        });
        
        return (
            <div className="layout-bc">
                <section className="col-b">
                    <div className="sub-module-split" data-behavior="equal_height">
                        <div className="module-split">
                            <MatchEvents eventStats={eventStats} home={homeTeam} away={awayTeam} />
                        </div>
                        <div className="module-split">
                            <KickPassRun colors={colors} values={metres} percent={metresPercent} kickPassRunStats={kickPassRunStats} home={homeTeam} away={awayTeam} />
                        </div>					
                    </div>
                    <AttackingStats colors={colors} attackingStats={attackingStats} possession={possession} territory={territory} home={homeTeam} away={awayTeam} />
                    <div className="sub-module-split" data-behavior="equal_height">
                        <div className="module-split">
                            <SetPieces colors={colors} lineOutsPieces={lineoutsWon} scrumPieces={scrumsWon} home={homeTeam} away={awayTeam} />
                        </div>
                        <div className="module-split">
                            <Defending colors={colors} tackles={tackles} home={homeTeam} away={awayTeam} />
                        </div>					
                    </div>
                    <Discipline colors={colors} pensConceded={pensConceded} disciplineStats={disciplineStats} home={homeTeam} away={awayTeam} />
                </section>
                <section className="col-c">
                    <article className="ad-300">
                        <div className="ad-center">
                            <Advert id='game.rhs.mpu' className="ad-slot-incontent ad-wrapper" slotType="incontent" />
                        </div>
                    </article>
                    <LeagueTable tableHref={this.props.tableHref} date="" name={leagueName} table={aLeagueTable} />
                    <NewsList header={newsList.header} link={newsList.link} articles={newsList.articles} />
                </section>
            </div>
        );
    }
});

module.exports = TabMatchStats;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/TabMatchStats.jsx
 **/